module.exports = __webpack_public_path__ + "img/mdi_calendar-clock.9ee29af4.svg";